<template>
  <h6 class="mb-0">{{ titlePage }}</h6>
  <p class="mb-0 text-sm">{{ subtitlePage }}</p>
  <hr class="my-3 horizontal dark" />
  <div class="row">
    <div class="col-4">
      <div class="form-group">
        <label for="subscriptionId" class="form-label">Subscription ID</label>
        <input id="fullName" type="text" class="form-control" disabled :value="record.id"/>
      </div>
    </div>
    <div class="col-4">
      <div class="form-group">
        <label for="email" class="form-label">Service Name</label>
        <input id="email" type="text" class="form-control" disabled :value="record.service_name" />
      </div>
    </div>
    <div class="col-4">
      <div class="form-group">
        <label for="email" class="form-label">Plan</label>
        <input id="email" type="text" class="form-control" disabled :value="record.pricing_data && record.pricing_data.pricing_models[0] && record.pricing_data.pricing_models[0].label.id" />
      </div>
    </div>
    <div class="col-4">
      <div class="form-group">
        <label class="form-label">Service Description</label>
        <input type="text" class="form-control" disabled :value="record.service_description"/>
      </div>
    </div>
    <div class="col-4">
      <div class="form-group">
        <label  class="form-label">Full Name</label>
        <input  type="text" class="form-control" disabled :value="record.full_name"/>
      </div>
    </div>
    <div class="col-4">
      <div class="form-group">
        <label  class="form-label">Trading Platform</label>
        <input  type="text" class="form-control" disabled :value="record.trading_platform"/>
      </div>
    </div>
    <div class="col-4">
      <div class="form-group">
        <label  class="form-label">Meta Account Number</label>
        <input  type="text" class="form-control" disabled :value="record.meta_account_number"/>
      </div>
    </div>
    <div class="col-4">
      <div class="form-group">
        <label  class="form-label">Meta Account Password Investor</label>
        <input  type="text" class="form-control" disabled :value="record.meta_account_master_password"/>
      </div>
    </div>
    <div class="col-4">
      <div class="form-group">
        <label  class="form-label">Live Server Name</label>
        <input  type="text" class="form-control" disabled :value="record.live_server_name"/>
      </div>
    </div>

    <div class="col-4">
      <div class="form-group">
        <label  class="form-label">Margin In</label>
        <input  type="number" class="form-control" disabled :value="record.margin.margin_in"/>        
      </div>      
    </div>

    <div class="col-4">
      <div class="form-group">
        <label  class="form-label">Rate</label>
        <input  type="number" class="form-control" disabled :value="record.margin.rate"/>        
      </div>      
    </div>

    <div class="col-4">
      <div class="form-group">
        <label  class="form-label">Target Profit %</label>
        <input  type="number" class="form-control" disabled :value="record.margin.target_profit"/>        
      </div>      
    </div>

    <div class="col-4">
      <div class="form-group">
        <label  class="form-label">Target Profit $</label>
        <input  type="number" class="form-control" disabled :value="getTargetProfitInDollar(record)"/>        
      </div>      
    </div>


    <div class="col-4">
      <div class="form-group">
        <label  class="form-label">Achieved Target %</label>
        <input  type="text" class="form-control" disabled :value="getAchieveInPercent(record)"/>        
      </div>      
    </div>

    <div class="col-4">
      <div class="form-group">
        <label  class="form-label">Outstanding Achievement %</label>
        <input  type="number" class="form-control" disabled :value="getOutstandingAchievement(record)"/>        
      </div>      
    </div>

    <div class="col-4">
      <div class="form-group">
        <label  class="form-label">Sas Fee {{ record?.margin?.sas_fee_type === "percentage" && '%' }}</label>
        <input  type="number" class="form-control" disabled :value="record?.margin?.sas_fee || 0"/>        
      </div>      
    </div>
    
    <div class="col-4">
      <div class="form-group">
        <label  class="form-label">Achieved Target in $</label>
        <input  type="number" class="form-control" v-model="record.margin.achieved_target"/>        
      </div>      
    </div>


  </div>
  
  
  
  <hr class="my-3 horizontal dark" />
  <div class="mt-4 d-flex justify-content-end">
    <a @click.prevent="$emit('cancel')" class="m-0 btn btn-light">
      Cancel
    </a>
    <button
    type="button"
    name="button"
    class="m-0 btn bg-gradient-success ms-2"
    @click="confirmationApprove()"
    
    >
    Submit
  </button>
</div>
</template>

<script>
import showPopupReject from "@/mixins/showSwal.js";
import showPopupUpdate from "@/mixins/showSwal.js";


export default {
  data() {
    return {
      statuses: ['active', 'waiting_confirmation', 'declined'],
      record: {margin: {achieved_target: 0, margin_in: 0, target_profit: 0}},
    };
  },
  props: {
    titlePage: String,
    subtitlePage: String,
    submitButtonName: String,
    onSubmit: { type: Function },
    toggleModal: { type: Function },
    recordProps: { type: Object }
  },
  watch: {
    recordProps: function (newVal, oldVal) { // watch it
      console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      this.record = newVal
    }
  },
  mixins: [showPopupReject, showPopupUpdate],
  methods: {
    getOutstandingAchievement(record) {
      const remaining = record.margin.target_profit - this.getAchieveInPercent(record)
      return remaining > 0 ? remaining : 0
    },
    getTargetProfitInDollar(record) {
      const targetProfitPercentage = record.margin.target_profit / 100

      return record.margin.margin_in * targetProfitPercentage
    },
    getAchieveInPercent(record) {
      return ((record.margin.achieved_target) / record.margin.margin_in) * 100
    },
    confirmationApprove(){
      this.showPopupUpdate().then((result) => {
          if (result.value) {
            const params = {
              achieved_target: this.record.margin.achieved_target
            }
            this.onSubmit(params)
          }
        });        
    },
    
  }
}
</script>
